import { StrictMode } from 'react'
import { createRoot }  from 'react-dom/client'
import App from './App.js'
import './styles/shadcn.css'
import '../tokens.css'
import './styles/operator-ui.css'
import './styles/form-surfaces.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
